import Select from "react-select";
import { useTranslation } from "react-i18next";
// import { usePossibleChildTrees } from "@hooks/usePossibleChildTrees";
import { usePossibleChildTrees } from "@hooks/useBackgroundData";

export default function ChildTree({ values, setFieldValue, formField }) {
  const { representTree } = formField;
  const { t } = useTranslation();

  // Use the cached possible child trees data
  const { possibleChildTrees, isLoading, isError } = usePossibleChildTrees();

  return (
    <div>
      <h6>{t(representTree.label)}</h6>
      <div>
        <Select
          classNamePrefix="react-select"
          id={"representTree"}
          type={"text"}
          value={
            values.represented_trees
              ? values.represented_trees?.map((representedTree) => ({
                  value: representedTree.id,
                  label:
                    representedTree.name ||
                    representedTree.tree_cadastre_no ||
                    `Tree ${representedTree.id}`,
                }))
              : []
          }
          onChange={(option) => {
            // Ensure we maintain all selected trees, including already represented ones
            const updatedTrees =
              option?.map((filteredTree) => ({
                id: parseInt(filteredTree.value),
                type: "Tree",
                name: filteredTree.label, // Include name for better data consistency
              })) || [];

            return setFieldValue("represented_trees", updatedTrees);
          }}
          options={possibleChildTrees} // Already formatted by the hook
          isMulti
          isLoading={isLoading}
          placeholder={
            isLoading
              ? t("loading_trees")
              : isError
              ? t("error_loading_trees")
              : t("select_child_trees")
          }
          noOptionsMessage={() =>
            isLoading
              ? t("loading_trees")
              : isError
              ? t("error_loading_trees")
              : t("no_trees_available")
          }
        />
      </div>
    </div>
  );
}
